import EA from 'helpers/init';
import gsap from 'gsap';

export default EA.Methods.mobileMenu = ($this) => {
    const tl = gsap.timeline();
    const anim = document.querySelectorAll('.mobile-anim');
    const nav = document.querySelector('.mobile-menu-wrap');
    const header = document.querySelector('.header');
    const burger = $this;

    tl.reverse();
    gsap.set(anim, {
        x: 40,
        alpha: 0
    });
    

    tl
        .to(nav, {
            x: '0%',
            duration: 0.6,
            ease: 'power2.inOut'
        })
        .to(anim, {
            x: 0,
            alpha: 1,
            stagger: 0.1,
            duration: 0.35,
            ease: 'power2.inOut'
        }, '-=0.17');

    burger.addEventListener('click', () => {
        burger.classList.toggle('active');
        header.classList.toggle('mobile');
        document.body.classList.toggle('overflow');
        tl.reversed() ? tl.play() : tl.reverse();
    });
};

